export default "__VITE_ASSET__BMf2w$na__"